import { PublicNav } from "@/components/public/PublicNav";
import { PublicFooter } from "@/components/public/PublicFooter";

export default function LegalShell({ eyebrow, title, intro, children, testid }) {
  return (
    <div className="min-h-screen bg-background text-foreground font-adminbody flex flex-col" data-testid={testid}>
      <PublicNav />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-5">{eyebrow}</div>
          <h1 className="font-admin font-extrabold text-4xl sm:text-5xl tracking-tight text-foreground">{title}</h1>
          {intro && <p className="mt-6 text-lg text-muted-foreground max-w-2xl leading-relaxed">{intro}</p>}
        </div>
        <div className="max-w-3xl mx-auto px-6 md:px-10 pb-24">{children}</div>
      </main>
      <PublicFooter />
    </div>
  );
}

export const Section = ({ title, children }) => (
  <section className="mb-12">
    <h2 className="font-admin font-bold text-xl mb-3 text-foreground">{title}</h2>
    <div className="text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </section>
);
